 <template>
  <div class="flex flex-col flex-1 md:ml-8 ml-4 mb-4">
    <JsonLd :entries="jsonLdEntries" />
    <div
      class="flex-1 relative mb-12"
      v-bind:key="index"
      v-for="(item, index) in items"
    >
      <div
        class="
          flex
          pb-4
          font-bold
          rounded-t-xl
          justify-between
          bg-transparent
          text-2xl
          groups
        "
        v-bind:id="'group-' + index"
      >
        {{ item.group.name }}
      </div>
      <div class="wrapper">
        <div
          v-for="faq in item.items"
          v-bind:key="faq.id"
          class="flex flex-col text-gray-800 border-2 border-gray-200 px-4 "
          v-bind:class="!faq.open ? 'hover:bg-primary-100' : 'bg-primary-100'"
        >
          <div
            class="
              flex
              font-bold
              text-lg
              justify-between
              py-3
              cursor-pointer
              items-center
           
            "
            v-on:click.prevent="toggleOpen(faq.id)"
          >
            {{ faq.question }}
            <span class="bg-primary-color rounded-lg text-white p-1">
              <ChevronUpIcon v-if="faq.open" class="w-6 h-6" />
              <ChevronDownIcon v-else class="w-6 h-6" />
            </span>
          </div>

          <div v-show="faq.open" class="py-4">{{ faq.answer }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
 
 

import { ChevronDownIcon, ChevronUpIcon } from "@vue-hero-icons/outline";
import JsonLd from "../../SEO/JsonLd.vue";
import { buildFaqPageSchema } from "../../../utils/structuredData";

export default {
  created() {
    this.axios.get("faq-data").then((response) => {
      if (response.data) {
        this.items = response.data;
      }
    });
  },

  updated() {

    this.getGroupName();
  
    if (this.groupsData && this.groupsData.length == 0) {
      this.groups.map((element, index) => {
        var yPosition = document
          .getElementById(element)
          .getBoundingClientRect().y;

        this.groupsData.push( yPosition );
      });

      this.titlePosition();
    }
  },

  mounted() {

  },

  data() {
    return {
      items: [],
      groupsData: [],
      groups: [],
      windowTop: 0,

    };
  },
  computed: {
    jsonLdEntries() {
      const faqs = this.items.reduce((allFaqs, item) => {
        return allFaqs.concat(item.items || []);
      }, []);

      if (!faqs.length) {
        return [];
      }

      return [
        buildFaqPageSchema({
          title: "Frequently Asked Questions",
          description:
            "Got questions? Find answers in our FAQ page.",
          faqs,
        }),
      ];
    },
  },
  methods: {
    titlePosition() {
      this.$emit("emitPosition", this.groupsData);
    },
    toggleOpen(faqId) {
      this.items.map((item, i) => {
        item["items"].map((faq, e) => {
          if (faqId == faq["id"]) {
            faq["open"] = faq["open"] != undefined ? !faq["open"] : this.$set(this.items[i].items[e], "open", true);
          } else {
            this.$set(this.items[i].items[e], "open", false);;
          }
        });
      });
    },

    getGroupName(){
      const listGroups = document.getElementsByClassName("groups");
 
      for(let i=0 ; i < listGroups.length ; i++){
        this.groups.push( listGroups[i].id );
      }
    }
  },
  components: {
    ChevronDownIcon,
    ChevronUpIcon,
    JsonLd,
  },
};
</script>